import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-ficha-obra-impressao',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ficha-obra-impressao.component.html',
})
export class FichaObraImpressaoComponent implements OnInit {
  @Input() idObra: number | number[] | null = null; 
  @Input() obra: any;
  @Input() dadosApi: any; 

  modalRef!: BsModalRef;
  isLoading: boolean = false; 

  constructor(private readonly modalService: BsModalService) {}

  ngOnInit(): void {
    if (
      !this.dadosApi ||
      !Array.isArray(this.dadosApi.works) ||
      this.dadosApi.works.length === 0
    ) {
      console.error(
        'Os dados da API não foram fornecidos ou estão incompletos ao componente de impressão.'
      );
      this.obra = null;
    } else {
      this.obra = this.dadosApi.works[0];

    }
  }

  abrirModalImpressao(): void {
    this.isLoading = true; 
    this.modalRef = this.modalService.show(FichaObraImpressaoComponent, {
      initialState: {
        idObra: this.idObra,
        dadosApi: this.obra,
      },
      class: 'modal-lg',
    });
    this.isLoading = false; 
  }

  imprimir(): void {
    const conteudo = document.getElementById('printOnly');
    if (!conteudo) return;

    const janela = window.open('', '_blank', 'width=800,height=600');
    if (!janela) return;

    const conteudoHTML = conteudo.innerHTML;

    janela.document.write(`
      <html>
        <head>
          <title>Impress&atilde;o
 - Ficha da Obra</title>
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css">
          <style>
            @media print {
              .no-print {
                display: none !important;
              }
            }
            body {
              font-family: Arial, sans-serif;
              color: #000;
              padding: 20px;
              background-color: #fff;
            }
          </style>
        </head>
        <body>
          ${conteudoHTML}
          <script>
            window.print();
          </script>
        </body>
      </html>
    `);
    janela.document.close();
  }

  fechar(): void {
    if (this.modalRef) {
      this.modalRef.hide();
    } else {
      console.error('ModalRef não está definido');
    }
  }

  getKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }

  isLastKey(key: string, obj: any): boolean {
    const keys = Object.keys(obj);
    return key === keys[keys.length - 1];
  }

  getOpcoes(valor: string): string[] {
    if (!valor) return [];
    return valor
      .split(',')
      .map((item) => item.trim())
      .filter((item) => item.length > 0);
  }

  temVariasOpcoes(valor: string): boolean {
    return typeof valor === 'string' && valor.includes(',');
  }

getStars(score: number | null): string {
  if (!score) return '';
  return '&#9733;'.repeat(score) + '&#9734;'.repeat(5 - score);
}
}
